import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from '../../../../environments/environment';
import { PresenterResourcesService } from '../presenter-resources.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pr-certification',
  templateUrl: './pr-certification.component.html',
  styleUrls: ['./pr-certification.component.scss']
})
export class PrCertificationComponent implements OnInit, OnDestroy {
  obj_container: any = [];
  env: any;
  
  private destroy$ = new Subject<void>();

  constructor(
    public router: Router,
    public store: Store<any>,
    private presenterResourcesService: PresenterResourcesService
  ) {}

  ngOnInit() {
    this.env = environment;
    
    this.presenterResourcesService.getFormattedLearnerMaps()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        formattedMaps => {
          this.obj_container = formattedMaps;
        },
        error => {
          console.error('Error loading learner maps:', error);
        }
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
